import { resolveProp } from '@clearscore/helpers.resolve-props';

/**
 * Returns an object of routes by id
 * @param collection Array
 * @param id String (id or id.key etc)
 */
const objectById = (collection, id = 'id') =>
    collection.reduce((state, item) => {
        const key = resolveProp(id, item);
        return {
            ...state,
            [key]: item,
        };
    }, {});

/**
 * Returns a simplified object with an array of ids
 * @param collection
 * @param id
 * @param name
 */
export const lookupById = (collection, id = 'id', name) =>
    collection.reduce((state, item) => {
        const reduceState = { ...state };
        if (item[id]) {
            if (Array.isArray(item[id])) {
                item[id].forEach((idvName) => {
                    if (!state[idvName]) {
                        reduceState[idvName] = {
                            id: idvName,
                            [name]: [item.id],
                        };
                    } else {
                        reduceState[idvName][name].push(item.id);
                    }
                });
            } else if (!state[item[id]]) {
                reduceState[item[id]] = {
                    id: item[id],
                    [name]: [item.id],
                };
            } else {
                reduceState[item[id]][name].push(item.id);
            }
        }
        return reduceState;
    }, {});

export default objectById;
